/* ============================================================
   Paleta de comandos / búsqueda instantánea (Ctrl/Cmd + K)
   Resultados en vivo desde /search/suggest.json con miniatura.
   ============================================================ */
(function () {
  'use strict';

  var modal = document.getElementById('tcg-cmd');
  if (!modal) return;

  var input = modal.querySelector('[data-cmd-input]');
  var results = modal.querySelector('[data-cmd-results]');
  var lastFocus = null;
  var items = [];
  var active = -1;
  var timer = null;
  var seq = 0;
  var panel = modal.querySelector('.tcg-cmd__panel');

  function open() {
    if (!modal.hidden) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { input.focus(); input.select(); });
  }
  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }

  // Conviven "CÓDIGO * Nombre * Rareza * Set" y "Nombre * Rareza * CÓDIGO"
  // (con el segundo, el panel enseñaba "Ultra Rare" como nombre). El nombre es
  // el primer segmento que no es un código (sin espacios, con guion o barra:
  // BROL-EN085, 189/166) ni una rareza. Misma regla que card-product.liquid.
  var RAREZA = /^(common|rare|short print|common \/ short print|.*rare.*|.*starlight.*|.*prismatic.*|uncommon|epic|legendary|overnumbered)$/i;
  function cleanTitle(t) {
    if (!t) return '';
    t = String(t).replace(/&apos;|&#39;/g, "'");
    if (t.indexOf(' * ') > -1) {
      var p = t.split(' * ').map(function (s) { return s.trim(); });
      for (var i = 0; i < p.length; i++) {
        var esCodigo = p[i].indexOf(' ') === -1 && /[-\/]/.test(p[i]);
        if (!esCodigo && !RAREZA.test(p[i])) return p[i];
      }
      return p[0];
    }
    var parts = t.split(' - ');
    if (parts.length >= 3 && /^[A-Z0-9]{2,6}-[A-Z0-9]+$/.test(parts[0].trim())) return parts[1].trim();
    return t;
  }
  function money(v) {
    if (!v && v !== 0) return '';
    var n = Math.round(parseFloat(v));
    if (isNaN(n)) return '';
    try { return '$' + n.toLocaleString('es-CO'); }
    catch (e) { return '$' + n; }
  }

  // Normaliza para comparar sin acentos/mayúsculas.
  function norm(s) {
    var t = String(s == null ? '' : s).toLowerCase();
    return t.normalize ? t.normalize('NFD').replace(/[̀-ͯ]/g, '') : t;
  }

  // Re-rankea por relevancia del NOMBRE (Shopify /search ordena por relevancia
  // de la página estándar, no como el predictive original). Priorizamos:
  // match exacto > empieza-con > palabra que empieza-con > contiene > resto.
  // El orden original de Shopify se conserva como desempate (sort estable).
  function rerank(products, q) {
    var nq = norm(q).trim();
    if (!nq) return products;
    function score(p) {
      var name = norm(cleanTitle(p.title)).trim();
      if (!name) return 5;
      if (name === nq) return 0;
      if (name.indexOf(nq) === 0) return 1;
      if (name.indexOf(' ' + nq) > -1) return 2; // otra palabra empieza con la query
      if (name.indexOf(nq) > -1) return 3;
      // fallback: por si el match está en el título crudo (set/código)
      if (norm(p.title).indexOf(nq) > -1) return 4;
      return 5;
    }
    return products
      .map(function (p, i) { return { p: p, s: score(p), i: i }; })
      .sort(function (a, b) { return a.s - b.s || a.i - b.i; })
      .map(function (x) { return x.p; });
  }

  function render(products, q) {
    items = [];
    active = -1;
    if (!products || !products.length) {
      /* Sin resultados: otro duelista puede tenerla. El Intercambio abre con la carta escrita. */
      results.innerHTML = '<div class="tcg-cmd__empty">Ninguna carta coincide. Prueba otro nombre o código.' +
        (q && q.length >= 3 ? '<a class="tcg-cmd__inter" href="/pages/comunidad-del-rincon?busco=' + encodeURIComponent(q) + '">' +
          '<b>¿No está en la tienda? Pídela en el Intercambio</b><span>Quien la tenga te escribe por WhatsApp</span></a>' : '') +
        '</div>';
      return;
    }
    var html = products.map(function (p, i) {
      var img = p.image || '';
      var sub = [p.number, p.rarity].filter(Boolean).join(' · ');
      var price = p.price || '';
      return '<a class="tcg-cmd__item" role="option" data-i="' + i + '" href="' + p.url + '">' +
        (img ? '<img class="tcg-cmd__thumb" src="' + img + '" alt="" loading="lazy">' : '<span class="tcg-cmd__thumb"></span>') +
        '<span class="tcg-cmd__meta"><span class="tcg-cmd__name">' + cleanTitle(p.title) + '</span>' +
        (sub ? '<span class="tcg-cmd__sub">' + sub + '</span>' : '') + '</span>' +
        (price ? '<span class="tcg-cmd__price">' + price + '</span>' : '') +
        '</a>';
    }).join('');
    /* Shopify casi siempre trae algo parecido aunque no esté la carta: el camino al Intercambio va también al final. */
    if (q && q.length >= 3) {
      html += '<a class="tcg-cmd__inter tcg-cmd__inter--pie" href="/pages/comunidad-del-rincon?busco=' + encodeURIComponent(q) + '">' +
        '<span>¿No está la que buscas?</span> <b>Pídela en el Intercambio</b></a>';
    }
    results.innerHTML = html;
    items = Array.prototype.slice.call(results.querySelectorAll('.tcg-cmd__item'));
  }

  function search(q) {
    if (!q || q.length < 2) {
      results.innerHTML = '<div class="tcg-cmd__hint">Escribe para ver cartas al instante…</div>';
      return;
    }
    var mySeq = ++seq;
    modal.classList.add('is-loading');
    // Vista propia /search?view=suggest -> JSON (pasa por el proxy, sin 401)
    var url = '/search?q=' + encodeURIComponent(q) + '&type=product&view=suggest';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (t) { try { return JSON.parse(t); } catch (e) { return []; } })
      .then(function (products) {
        if (mySeq !== seq) return; // respuesta obsoleta
        modal.classList.remove('is-loading');
        render(rerank(Array.isArray(products) ? products : [], q), q);
      })
      .catch(function () { if (mySeq === seq) { modal.classList.remove('is-loading'); render([], q); } });
  }

  function setActive(idx) {
    if (!items.length) return;
    if (active > -1 && items[active]) items[active].classList.remove('is-active');
    active = (idx + items.length) % items.length;
    items[active].classList.add('is-active');
    items[active].scrollIntoView({ block: 'nearest' });
  }

  // Eventos input
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    timer = setTimeout(function () { search(q); }, 160);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
    else if (e.key === 'Enter') {
      if (active > -1 && items[active]) { window.location.href = items[active].getAttribute('href'); }
      else if (input.value.trim()) { window.location.href = '/search?q=' + encodeURIComponent(input.value.trim()) + '&type=product'; }
    }
  });

  // Abrir/cerrar globales
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) { close(); return; }
    // Atajo propio: "/" (no Ctrl+K). Solo si no se está escribiendo en un campo.
    if ((e.key === '/' || e.key === 'º') && modal.hidden) {
      var t = e.target;
      var tag = t && t.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (t && t.isContentEditable)) return;
      e.preventDefault();
      open();
    }
  });

  document.addEventListener('pointerdown', function (e) {
    if (modal.hidden) return;
    if (e.target.closest('[data-cmd-open]')) return;
    if (panel && panel.contains(e.target)) return;
    close();
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cmd-close]')) { close(); return; }
    if (e.target.closest('[data-cmd-open]')) { e.preventDefault(); open(); }
  });

  // Disparador visible en el header (descubribilidad)
  function injectTrigger() {
    var header = document.querySelector('.header');
    if (!header || header.querySelector('.tcg-search-trigger')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tcg-search-trigger';
    btn.setAttribute('data-cmd-open', '');
    btn.setAttribute('aria-label', 'Buscar cartas (atajo: tecla /)');
    /* Lupa como SVG, no como glifo: el ⌕ (U+2315) dependia de la fuente del
       sistema y era el unico icono del header que no era vectorial. */
    btn.innerHTML = '<span class="tcg-search-trigger__ico" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.2 15.2 4.8 4.8"/></svg></span>' +
      '<span class="tcg-search-trigger__label">Buscar carta</span>' +
      '<kbd>/</kbd>';
    var icons = header.querySelector('.header__icons');
    if (icons) icons.insertBefore(btn, icons.firstChild);
    else header.appendChild(btn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectTrigger);
  else injectTrigger();
})();
